import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { BaseMapper } from "../../utils/mappers/shared/base.mapper";
import { PagedApiResponse } from "../../utils/types/shared/paged-api-response.type";
import { SharedMapper } from "../../components/shared/shared.mapper";
import { FilterType } from "../../utils/types/shared/filter.type";
import { KeyValue } from "../../utils/types/shared/keyvalue.type";
import { environment as env } from "../../../environments/environment";
import { Delimiter } from "../../utils/types/shared/delimiter";
import { Organization } from "../../utils/types/shared/organization";
import { ShortCode } from "../../utils/types/shared/shortcode.type";
import { User } from "../../utils/types/security/user.type";
import { ShortCodesKeyword } from "../../utils/types/shared/shortcodeskeyword";
import { map } from "rxjs/operators";

export class SharedCatalogMapper extends BaseMapper<KeyValue> {}

export class ShortCodeMapper extends BaseMapper<ShortCode> {}

export class ShortCodesKeywordMapper extends BaseMapper<ShortCodesKeyword> {}

@Injectable()
export class SharedCatalogService {
    ENUMS_BASE_URL = env.ApiUrl;

    ENUMS_ENDPOINTS = {
        organization:
            this.ENUMS_BASE_URL + "api/organization/{id}/shortcodes/objects",
        UserInfo: this.ENUMS_BASE_URL + "/user/{userId}",
    };

    apiEndPoint = this.ENUMS_ENDPOINTS;
    mapper = new SharedCatalogMapper();
    shortCodeMapper = new ShortCodeMapper();
    shortCodesKeywordMapper = new ShortCodesKeywordMapper();

    constructor(private http: HttpClient) {}

    getDelimiters(): Array<Delimiter> {
        const delimiters: Delimiter[] = [
            { id: 1, delimiterValue: "Coma [ , ]", value: "," },
            { id: 2, delimiterValue: "Tab [ ]", value: "\t" },
            { id: 3, delimiterValue: "Semmicolon [ ; ]", value: ";" },
            { id: 4, delimiterValue: "Pipe [ | ]", value: "|" },
        ];

        return delimiters;
    }

    getShortcodes(): Observable<KeyValue[]> {
        return this.http.get(this.apiEndPoint.organization).pipe(
            map((res: any) => {
                const organization = SharedCatalogMapper.map(res, Organization);
                const shortCodeList: KeyValue[] = new Array<KeyValue>();

                organization.shortCodes.forEach(function (entry) {
                    const shortCodekeyvalue = new KeyValue();
                    shortCodekeyvalue.id = entry.id;
                    shortCodekeyvalue.code = entry.value;
                    shortCodekeyvalue.name =
                        entry.operator.name + " - " + entry.value;

                    shortCodeList.push(shortCodekeyvalue);
                });

                return shortCodeList;
            })
        );
    }

    getShortcodesObjects(companyId: Number): Observable<ShortCode[]> {
        return this.http
            .get(
                this.apiEndPoint.organization.replace(
                    "{id}",
                    companyId.toString()
                )
            )
            .pipe(
                map((res: any) => {
                    return this.shortCodeMapper.mapList(res, ShortCode);
                })
            );
    }

    /*  gethortcodesAndKeyword(): Observable<ShortCodesKeyword[]>{

        return this.http.get('http://mm.apicontent.info/services/get/').map((res: any) => {

            return this.shortCodesKeywordMapper.mapList(res, ShortCodesKeyword);

        });


    } */
}
